// extracted by mini-css-extract-plugin
export default {"root":"ShopBlocks_root__GogMf","title":"ShopBlocks_title__2EZPl","blocks":"ShopBlocks_blocks__38y0M","block":"ShopBlocks_block__3Mzfg","blockTitle":"ShopBlocks_blockTitle__3BUsJ"};